export type ExtensionSection = "returnButton" | "giftCode";

export interface ExtensionKeyDescriptor {
  section: ExtensionSection;
  key: string;
  path: string;
  label: string;
  placeholder: Record<string, string>;
}

export const SECTION_LABELS: Record<ExtensionSection, string> = {
  returnButton: "Bouton de retour",
  giftCode: "Gift Code",
};

export const EXTENSION_KEYS: ExtensionKeyDescriptor[] = [
  {
    section: "returnButton",
    key: "label",
    path: "returnButton.label",
    label: "Label du bouton",
    placeholder: {
      en: "Return my order",
      fr: "Retourner ma commande",
      de: "Meine Bestellung zurückgeben",
      es: "Devolver mi pedido",
      it: "Restituisci il mio ordine",
      nl: "Mijn bestelling retourneren",
      pt: "Devolver meu pedido",
    },
  },
  {
    section: "giftCode",
    key: "title",
    path: "giftCode.title",
    label: "Titre",
    placeholder: {
      en: "Claim Your Gift",
      fr: "Obtenez votre cadeau",
      de: "Holen Sie sich Ihr Geschenk",
      es: "Reclama tu regalo",
      it: "Richiedi il tuo regalo",
      nl: "Claim je cadeau",
      pt: "Resgate seu presente",
    },
  },
  {
    section: "giftCode",
    key: "description",
    path: "giftCode.description",
    label: "Description",
    placeholder: {
      en: "Thank you for your purchase! Claim your exclusive gift code below.",
      fr: "Merci pour votre achat ! Obtenez votre code cadeau exclusif ci-dessous.",
      de: "Vielen Dank für Ihren Einkauf! Holen Sie sich unten Ihren exklusiven Geschenkcode.",
      es: "¡Gracias por tu compra! Reclama tu código de regalo exclusivo a continuación.",
      it: "Grazie per il tuo acquisto! Richiedi il tuo codice regalo esclusivo qui sotto.",
      nl: "Bedankt voor je aankoop! Claim hieronder je exclusieve cadeaucode.",
      pt: "Obrigado pela sua compra! Resgate seu código de presente exclusivo abaixo.",
    },
  },
  {
    section: "giftCode",
    key: "linkText",
    path: "giftCode.linkText",
    label: "Texte du lien",
    placeholder: {
      en: "Get your gift code",
      fr: "Obtenir votre code cadeau",
      de: "Geschenkcode erhalten",
      es: "Obtener tu código de regalo",
      it: "Ottieni il tuo codice regalo",
      nl: "Cadeaucode ophalen",
      pt: "Obter seu código de presente",
    },
  },
];
